import * as React from "react";
import { withStyles } from "src/decorators";
import styled, { css } from "styled-components";
import { HTMLProps } from "react";
import "./Loading.style.scss";
import classNames from "classnames";

type Props = HTMLProps<HTMLDivElement> & {
  tiny?: boolean;
  compact?: boolean;
  noMargin?: boolean;
  secondary?: boolean;
};

const sizeStyle = (size: number, borderWidth = 4) => css`
  border-width: ${borderWidth}px;
  max-width: ${size}px;
  min-width: ${size}px;
  max-height: ${size}px;
  min-height: ${size}px;
`;

const SpinnerEl = styled.div<Props>`
  border: 4px solid
    ${(props) =>
      props.secondary
        ? props.theme.colors.background.white
        : props.theme.colors.background.primary};
  border-top: 4px solid ${(props) => props.theme.colors.borders.light};
  border-radius: 50%;
  animation: ${(props) => props.theme.animations.spin};

  ${sizeStyle(24)}

  ${(p) => p.compact && sizeStyle(12, 2)}
  
  ${(p) => p.tiny && sizeStyle(10, 2)}
`;

export const Loading = withStyles((props: Props) => {
  const { tiny, compact, noMargin, secondary, className, ...other } = props;

  const _className = classNames(
    "tjr-flex",
    "asp-loading",
    "tjr-justify-center",
    {
      "tjr-margin-top-xl tjr-margin-bottom-xl": !noMargin && !tiny && !compact,
      "tjr-margin-top-s tjr-margin-bottom-s": !noMargin && !tiny && !compact,
    },
    className
  );

  return (
    <div {...other} className={_className}>
      <SpinnerEl secondary={secondary} tiny={tiny} compact={compact} />
    </div>
  );
});
